// eslint-disable-next-line import/prefer-default-export
export const LARGE_FILE_ERROR = 'File size should be less than 20mb';
